import { RPCs } from "../../../services/rpc.js";
import { useRPC } from "../../../hooks/useRPC/index.js";
//#region src/modules/Users/hooks/useUsers.ts
function useUsers(args, opts = {}) {
	const fire = typeof opts.fire === "boolean" ? opts.fire : true;
	const { call, data, isCalling } = useRPC(RPCs.Users.GetUsersList.v1, args, {
		cacheStrategy: opts.cacheStrategy,
		fire: !!args && fire,
		persistPreviousData: opts.persistPreviousData
	});
	return {
		data,
		loading: isCalling,
		refresh: call
	};
}
//#endregion
export { useUsers };

//# sourceMappingURL=useUsers.js.map